import { Button, Container, Typography } from '@app/components';
import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PermissionCrown } from '@app/domain/plan/components/permission-crown/PermissionCrown';
import { useGPSPreferences } from '../hooks/useGPSPreferences';
import { TranslationKey } from '@app/locales/defaultTranslation';

export const AccountQRCodePreferences: React.FC<{ title?: TranslationKey }> = ({ title }) => {
  const { t } = useTranslation();
  const { useGPS, isLoading, disableSubmitButton, handleToggleGPS, handleSaveChanges, canTrackGPS } =
    useGPSPreferences();

  return (
    <Container className="flex flex-col gap-6 p-6 lg:rounded-xl">
      <Typography variant="m" className="font-bold flex items-center gap-2">
        {!title ? t('account.sectionQRPreferences.title') : t(title)}
        <PermissionCrown requireUpgrade={!canTrackGPS} />
      </Typography>

      <div className="flex flex-col gap-4 lg:flex-row lg:gap-12">
        <div>
          <FormControlLabel
            onChange={handleToggleGPS}
            checked={useGPS}
            control={<Switch />}
            label={t('account.sectionQRPreferences.useGPSBasedLocation')}
          />
        </div>
      </div>
      <div>
        <Button
          onClick={handleSaveChanges}
          color="secondary"
          disabled={disableSubmitButton}
          variant="outlined"
          loading={isLoading}
          className="w-[220px]"
        >
          {t('dialog.saveChanges')}
        </Button>
      </div>
    </Container>
  );
};
